<!--  报销申请页面  -->
<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        报销申请
        <small>报销申请</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> 报销申请
          </a>
        </li>
        <li class="active">报销申请</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="col-sm-12">
        <div id="atptoolbar"></div>

        <!--  申请表单  -->
        <div class="apply-form">
          <!-- modal-body-->
          <div class="modal-body">

            <div class="panel-body">

              <div class="form-group">
                <label class="control-label col-xs-12 col-sm-6 no-padding-right"
                       for="useTime">报销日期:
                  <input
                    id="useTime"
                    name="useTime"
                    type="text"
                    class="form-control field"
                    @click="datePicker('useTime')"
                  />
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  报销金额
                  <input type="number" class="form-control" v-model="form.money"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  发票金额
                  <input type="number" class="form-control" v-model="form.invoiceMoney"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  费用类别
                  <input type="text" class="form-control" v-model="form.type"
                         placeholder="请输入费用类别"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  开票单位
                  <input type="text" class="form-control" v-model="form.invoiceOrg"
                         placeholder="请输入开票单位"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  支付方式
                  <select class="form-control" v-model="form.payMethod">
                    <option value="">请选择支付方式</option>
                    <option value="现金">现金</option>
                    <option value="网银">网银</option>
                    <option value="支票">支票</option>
                    <option value="电汇">电汇</option>
                  </select>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  发票形式
                  <select class="form-control" v-model="form.invoiceType">
                    <option value="">请选择发票形式</option>
                    <option value="专票">专票</option>
                    <option value="普票">普票</option>
                    <option value="收据">收据</option>
                    <option value="白条">白条</option>
                  </select>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  发票税率
                  <input type="number" class="form-control" v-model="form.invoiceTaxRate"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  发票号
                  <input type="text" class="form-control" v-model="form.invoiceNo"
                         placeholder="请输入发票号"/>
                </label>
                <label class="control-label col-xs-12 col-sm-6 no-padding-right"
                       for="receiptDate">实际支付日期:
                  <input
                    id="receiptDate"
                    name="receiptDate"
                    type="text"
                    class="form-control field"
                    @click="datePicker('receiptDate')"
                  />
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  备注
                  <input type="text" class="form-control" v-model="form.remark"
                         placeholder=""/>
                </label>
              </div>

            </div>

          </div>
          <!-- modal-footer -->
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
            <button type="button" class="btn btn-primary" @click="submit">确定</button>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>

  import {datepicker} from 'eonasdan-bootstrap-datetimepicker'

  export default {
    name: 'applyReimbursement',
    data() {
      return {
        form: {
          useTime: '', // 报销日期
          money: '', // 报销金额
          invoiceMoney: '', // 发票金额
          type: '', // 费用类别
          invoiceOrg: '', // 开票单位
          payMethod: '', // 支付方式
          invoiceType: '', // 发票形式
          invoiceTaxRate: '', // 发票税率
          invoiceNo: '', // 发票号
          remark: '', // 备注
          receiptDate: '' // 实际支付日期
        }
      }
    },

    components: {datepicker},

    mounted: function () {
    },

    methods: {
      submit: function () { // 发起报销申请
        let self = this
        const company = localStorage.getItem('companyInfo')
        console.log(self.form)
        if (!self.form.useTime || !self.form.money || !self.form.invoiceMoney || !self.form.type || !self.form.invoiceOrg ||
          !self.form.payMethod || !self.form.invoiceType || !self.form.invoiceTaxRate || !self.form.receiptDate) {
          alert('请将申请单填写完毕')
          return
        }
        const formData = {
          '公司ID': JSON.parse(company).id,
          '报销日期': self.form.useTime,
          '报销金额': self.form.money,
          '发票金额': self.form.invoiceMoney,
          '费用类别': self.form.type,
          '开票单位': self.form.invoiceOrg,
          '支付方式': self.form.payMethod,
          '发票形式': self.form.invoiceType,
          '发票税率': self.form.invoiceTaxRate,
          '发票号': self.form.invoiceNo,
          '备注': self.form.remark,
          '实际支付日期': self.form.receiptDate
        }

        self.global.axiosPost(self, 'apply/3/', formData, function (res) {
          console.log('/apply/3/', res)
          if (res.status === 'success') {
            alert('提交成功')
          }
        })
      },

      datePicker: function (elementId) {
        let self = this
        WdatePicker({
          el: elementId,
          dateFmt: 'yyyy-MM-dd HH:mm:ss', //日期格式，可以只显示年或年月，也可以额外显示时间
          onpicked: function () {
            var value = $('#' + elementId).val()
            console.log('___日期elementId', elementId, value)
            // var timeStamp = self.global.timeToStamp(value)
            self.form[elementId] = value
          },
          oncleared: function () {
            self[elementId] = null
          },
          isShowClear: true,
          readOnly: true
        })
      },

    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/applyWorkflow/applyReimbursement.vue